import { ApiClient } from './client'
export const PHOTO_FRAMING_ALGORITHM = 'pico-v1' as const
export interface PhotoFace { x: number; y: number; width: number; height: number }
export interface PhotoFraming {
  imageVersion: string
  algorithmVersion: string
  status: 'pending' | 'detected' | 'no-face' | 'multiple'
  face: PhotoFace | null
}
export interface PhotoFramingScope { clubId: string; seasonId: string; eventId: string; participantId: string }
export type CompletedPhotoFraming = PhotoFraming & { status: 'detected' | 'no-face' | 'multiple' }
const client = new ApiClient(undefined, { logoutOnUnauthorized: false })
export const photoFramingAPI = {
  save(scope: PhotoFramingScope, framing: CompletedPhotoFraming, token: string, signal?: AbortSignal) {
    const path = `/v2/season/${encodeURIComponent(scope.seasonId)}/tryouts/${encodeURIComponent(scope.eventId)}/capture/participants/${encodeURIComponent(scope.participantId)}/photo-framing`
    return client.put<{ photoFraming: PhotoFraming }>(path, framing, { clubId: scope.clubId }, signal, token)
  },
}
